import React, { memo } from "react";
import { FixedSizeList as List } from "react-window";
import { Box, Stack } from "@mui/material";
import CardMaps from ".";

const VirtualizedMaps = memo(
  ({ maps, alertsDataMap, style, search }) => {
    // Define a altura de cada item (ajuste conforme necessário)
    const isScrolling = maps.length * 100 > window.innerHeight;
    // Renderiza cada item virtualizado
    const Row = ({ index, style }) => {
      const map = maps[index];

      return (
        <Box sx={style}>
          <CardMaps
            map={map}
            alertas={alertsDataMap.get(map?.id)?.length || 0}
            setFocusNodeId={search}
            isScrolling={isScrolling}
          />
        </Box>
      );
    };

    return (
      <Stack direction="column" gap={1} sx={[style, { paddingRight: "0px" }]}>
        <List
          key={Math.random()}
          height={window.innerHeight} // Altura visível do container da lista
          itemCount={maps.length} // Total de itens na lista
          itemSize={100} // Altura de cada item
          width="100%" // Largura do container da lista
        >
          {Row}
        </List>
      </Stack>
    );
  },
  (prevProps, nextProps) => {
    return JSON.stringify(prevProps.maps) == JSON.stringify(nextProps.maps);
  }
);

export default VirtualizedMaps;
